import NewExecutiveReport from './new/NewExecReportContainer';
import ExecutiveReportDetail from './detail/ExecReportDetail';
import ExecutiveReportListContainer from './ExecutiveReportListContainer';

const ExecutiveReportRoutes = [
  { path: '/accounts/:aid/executive-reports/', component: ExecutiveReportListContainer, exact: true },
  { path: '/accounts/:aid/executive-reports/new', component: NewExecutiveReport },
  { path: '/accounts/:aid/executive-reports/:reportId', component: ExecutiveReportDetail },
];

export default ExecutiveReportRoutes;
